module.exports = __webpack_public_path__ + "static/img/blg-light-logo-im.63a9b2f5.png";